import {
    GET_MAQUINA_DETALLES, ADD_NEW_MAQUINA, ADD_CONTADOR_MAQUINA, MODIFY_CONTADOR_MAQUINA, DELETE_CONTADOR_MAQUINA
} from '../constants/action_types';

const initialState = { maquinaContadores: [], isLoading: false };

export default function (state = initialState, action) {

    const tiposContadores = ['Euros', 'Tokens', 'Tickets', 'Cambio', 'Regalos','VISAs'];

    switch (action.type) {
        case GET_MAQUINA_DETALLES:

            return {
                maquinaContadores: [],
                isLoading: true
            };

        case GET_MAQUINA_DETALLES + "_SUCCESS":

            const newCont = action.payload.data.contadores.map(c => {
               return {...c, tipoContador: tiposContadores[c.iTipo]}
            })

            return {
                maquinaContadores: newCont,
                isLoading: false
            };


        case ADD_CONTADOR_MAQUINA:

            const newArr = [...state.maquinaContadores, action.payload]

            return {
                maquinaContadores: newArr,
                isLoading: false
            };

        case MODIFY_CONTADOR_MAQUINA:

            return {
                maquinaContadores: state.maquinaContadores.map((contador) => {
                    if (contador.id !== action.payload.id) return contador;
                    else return {...action.payload, tipoContador: tiposContadores[action.payload.iTipo]};
                }),
                isLoading: false
            };

        case DELETE_CONTADOR_MAQUINA:

            return {
                maquinaContadores: state.maquinaContadores.filter(contador => contador.id !== action.payload.id),
                isLoading: false
            };

        case ADD_NEW_MAQUINA:
            return initialState;

        default:

            return state;
    }

}